/**
 * PM - Navegación rápida hacia Collection (baseline "Agotados OFF").
 *
 * Objetivo: que un click NORMAL del usuario sobre un link interno a
 * Collection resulte en UNA sola navegación ya filtrada
 * (/collections/foo?filter.v.availability=1), sin que
 * snippets/pm-availability-default-redirect.liquid tenga que hacer
 * location.replace() (segunda navegación completa, causa confirmada de la
 * demora de ~1s reportada en Collection).
 *
 * DECISIÓN DE ARQUITECTURA (corrige una ronda anterior que parametrizaba el
 * href directamente en el HTML): el href en el markup se mantiene SIEMPRE
 * limpio (/collections/foo, sin query) -- eso es lo que ve un crawler, lo
 * que se comparte/copia, y lo que aparece en Analytics como landing page.
 * Solo el comportamiento del click se intercepta, y solo para los links que
 * nosotros marcamos explícitamente:
 *
 *   <a href="/collections/foo" data-pm-collection-link>...</a>
 *
 * NO se interceptan todos los <a> del sitio -- solo los que llevan ese
 * data-attribute (megamenú, nav principal, menú mobile, sidebar de
 * colección, Popular Collections, Collection Tabs). Un link marcado que en
 * realidad no apunta a /collections/* (ej. un campo de CTA/promo que el
 * merchant configuró hacia una página) simplemente no se toca: la función
 * de abajo revisa el pathname real antes de actuar.
 *
 * Se respeta el comportamiento nativo del navegador en todos los casos que
 * no son "click normal de navegación en la misma pestaña":
 *   - Ctrl/Cmd/Shift/Alt + click (abrir en pestaña/ventana nueva)
 *   - click central (scroll wheel)
 *   - botón derecho > copiar enlace / abrir en pestaña nueva
 *   - cualquier otro evento con preventDefault ya aplicado
 * En esos casos el navegador usa el href limpio tal cual, y
 * pm-availability-default-redirect.liquid sigue actuando como red de
 * seguridad exactamente igual que antes (sin cambios en ese archivo).
 *
 * REVERTIDO (hotfix 2026-09-14): una ronda anterior agregó un <link
 * rel="prefetch"> especulativo del documento en pointerenter/focusin sobre
 * estos links. Alejandro confirmó que un hover normalmente termina en click
 * casi inmediato -- eso significaba iniciar una navegación especulativa del
 * documento justo antes de la navegación real, compitiendo por la misma
 * conexión/prioridad. Se retira por completo esa parte; esta función vuelve
 * a hacer EXCLUSIVAMENTE lo que hacía originalmente: interceptar el click
 * normal y navegar directo con filter.v.availability=1.
 */
(function () {
  function buildFilteredUrl(href) {
    if (!href) {
      return null;
    }

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin) {
      return null;
    }

    // PM - hotfix 2026-09-14: antes usaba pathname.includes('/collections/'),
    // que también hacía match en rutas de PRODUCTO anidadas dentro de una
    // colección (/collections/<handle>/products/<handle>, un link válido de
    // Shopify) -- eso habría agregado filter.v.availability=1 a una URL de
    // producto por error. Ahora exige EXACTAMENTE un segmento "collections"
    // seguido de un único segmento (el handle) y nada más, tolerando
    // cualquier prefijo de ruta localizada (/es/collections/altavoces,
    // /pt-BR/collections/altavoces, etc.) sin necesitar conocer la lista de
    // idiomas habilitados.
    var segments = url.pathname.split('/').filter(Boolean);
    var collectionsIndex = segments.indexOf('collections');
    if (collectionsIndex === -1 || segments.length !== collectionsIndex + 2) {
      return null;
    }

    if (url.searchParams.has('filter.v.availability')) {
      return null;
    }

    url.searchParams.set('filter.v.availability', '1');
    return url.toString();
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) {
      return;
    }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var link = event.target.closest('[data-pm-collection-link]');
    if (!link) {
      return;
    }
    if (link.target && link.target !== '_self') {
      return;
    }

    var targetUrl = buildFilteredUrl(link.getAttribute('href'));
    if (!targetUrl) {
      return;
    }

    event.preventDefault();
    window.location.assign(targetUrl);
  });
})();
